import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const Home = () => {
    const navigate = useNavigate();

    const cards = [
        { id: 1, title: "Administración", buttonText: "Ingresar", image: "/images/administration.png", route: "/admin" },
        { id: 2, title: "Profesores", buttonText: "Ingresar", image: "/images/teachers.png", route: "/profesores" },
        { id: 3, title: "Asistencia", buttonText: "Ingresar", image: "/images/assistance.png", route: "/asistencia" },
        { id: 4, title: "Estudiantes", buttonText: "Ingresar", image: "/images/students.png", route: "/estudiantes" },
        { id: 5, title: "Reportes", buttonText: "Ingresar", image: "/images/reports.png", route: "/reportes" }
    ]; 

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                {cards.map((card) => (
                    <Col key={card.id} md={4} sm={6} xs={12} className="mb-4">
                        <Card className="home-card">
                            <div className="card-overlay" style={{ backgroundImage: `url(${card.image})` }}>
                                <div className="overlay-content">
                                    <h4>{card.title}</h4>
                                    <Button variant="dark" onClick={() => navigate(card.route)}>
                                        {card.buttonText}
                                    </Button>
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default Home;
